import React, { PureComponent, FunctionComponent } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Button, ButtonColor } from '@pegasus/ui-components/components/button';
import styles from './BannerContent.scss';
import { THB } from '@shared/types/campaign';


interface BannerContentProps {
    thb: THB;
    onButtonClick: (event: React.MouseEvent) => void;
}

export const BannerContent: FunctionComponent<BannerContentProps>= ({ thb: { text, url }, onButtonClick }) => {
    const allWhitespaces = /^(\s)+$/;
    const validText = text && typeof text === 'string' && !allWhitespaces.test(text);
    const validTarget = !url || !isEmpty(url);

    return validText && validTarget && (
        <div styleName="wrapper">
            <div styleName="button-container">
                <Button color={ButtonColor.bright} onClick={onButtonClick} fullWidth>
                    { text }
                </Button>
            </div>
        </div>
    );
}


export default CSSModules(BannerContent, styles, { allowMultiple: true });
